// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
    font-size: 0.9em;
    font-weight: 500;
    /* font-weight: bold; */
    margin-top: 20px;
    padding: 0 10px 10px 10px;
    background-color: lightgray;
}

footer h2 {
    color:#FFEA00;
    font-size: 1.3em;
    text-shadow: black 2px 1px 3px;
}

footer a {
    display: block;
    padding: 10px 0 10px 10px;
    color: black;
    text-shadow: gray 4px 2px 5px;
    text-decoration: none;
}

footer a:hover {
    background: gray;
    color: #FFEA00;
    text-shadow: black 5px 2px 5px;  
    cursor: pointer;
}

footer ul {
    list-style-type:none;
    margin: 0;
    padding: 0;
    flex-basis: 50%;
    justify-self:self-start;
}

footer p {
    text-align: center;
    padding-bottom: 20px;
}

#footer-info {
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    justify-content: space-around; 
    padding-top: 10px;
    margin-bottom: 15px;
}

.footer-block {
    /* flex-basis: 100%; */
    margin-bottom: 10px;
}

#copyright {
    margin-bottom: 0px;
    /* background-image: url('copy-bg1.png');
    background-position: center;
    background-repeat: no-repeat; */
}  

#copyright a {
    display: inline;
    color: cadetblue;
    font-weight: 700;
    text-shadow: black 2px 1px 3px; 
}

#copyright a:hover {
    color: cadetblue;
    font-weight: 700;
    text-shadow: gray 2px 1px 3px;     
    background-color: lightgray;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,SAAS;IACT,UAAU;IACV,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB;;mCAE+B;AACnC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,2BAA2B;AAC/B","sourcesContent":["footer {\r\n    font-size: 0.9em;\r\n    font-weight: 500;\r\n    /* font-weight: bold; */\r\n    margin-top: 20px;\r\n    padding: 0 10px 10px 10px;\r\n    background-color: lightgray;\r\n}\r\n\r\nfooter h2 {\r\n    color:#FFEA00;\r\n    font-size: 1.3em;\r\n    text-shadow: black 2px 1px 3px;\r\n}\r\n\r\nfooter a {\r\n    display: block;\r\n    padding: 10px 0 10px 10px;\r\n    color: black;\r\n    text-shadow: gray 4px 2px 5px;\r\n    text-decoration: none;\r\n}\r\n\r\nfooter a:hover {\r\n    background: gray;\r\n    color: #FFEA00;\r\n    text-shadow: black 5px 2px 5px;  \r\n    cursor: pointer;\r\n}\r\n\r\nfooter ul {\r\n    list-style-type:none;\r\n    margin: 0;\r\n    padding: 0;\r\n    flex-basis: 50%;\r\n    justify-self:self-start;\r\n}\r\n\r\nfooter p {\r\n    text-align: center;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n#footer-info {\r\n    display: flex;\r\n    flex-flow: row;\r\n    flex-wrap: wrap;\r\n    justify-content: space-around; \r\n    padding-top: 10px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.footer-block {\r\n    /* flex-basis: 100%; */\r\n    margin-bottom: 10px;\r\n}\r\n\r\n#copyright {\r\n    margin-bottom: 0px;\r\n    /* background-image: url('copy-bg1.png');\r\n    background-position: center;\r\n    background-repeat: no-repeat; */\r\n}  \r\n\r\n#copyright a {\r\n    display: inline;\r\n    color: cadetblue;\r\n    font-weight: 700;\r\n    text-shadow: black 2px 1px 3px; \r\n}\r\n\r\n#copyright a:hover {\r\n    color: cadetblue;\r\n    font-weight: 700;\r\n    text-shadow: gray 2px 1px 3px;     \r\n    background-color: lightgray;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
